import { createSlice } from "@reduxjs/toolkit";
import club_img_1 from "assets/images/club-img-1.png";
import batting_logo from "assets/images/batting-logo.png";

const initialState = {
  data: [
    {
      name: "RC99 Cricket Club",
      country: "Pakistan",
      logo: club_img_1,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "RC99 Cricket Club",
      country: "Pakistan",
      logo: club_img_1,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "RC99 Cricket Club",
      country: "Pakistan",
      logo: club_img_1,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "RC99 Cricket Club",
      country: "Pakistan",
      logo: club_img_1,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "RC99 Cricket Club",
      country: "Pakistan",
      logo: club_img_1,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "RC99 Cricket Club",
      country: "Pakistan",
      logo: club_img_1,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "RC99 Cricket Club",
      country: "Pakistan",
      logo: club_img_1,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "RC99 Cricket Club",
      country: "Pakistan",
      logo: club_img_1,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "RC99 Cricket Club",
      country: "Pakistan",
      logo: club_img_1,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "RC99 Cricket Club",
      country: "Pakistan",
      logo: club_img_1,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "RC99 Cricket Club",
      country: "Pakistan",
      logo: club_img_1,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "RC99 Cricket Club",
      country: "Pakistan",
      logo: club_img_1,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "RC99 Cricket Club",
      country: "Pakistan",
      logo: club_img_1,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
    {
      name: "Brew Club",
      country: "Pakistan",
      logo: batting_logo,
      playerHistoryTitle: ["Team", "Player", "Matches", "Competitions"],
      playerHistory: [7, 6, 1, 0],
    },
  ],
};

export const clubDetails = createSlice({
  name: "relatedMatchData",
  initialState,
});

export default clubDetails.reducer;
